import React from 'react'

export function NotFoundPage() {
    return <img src="https://cdn.svgator.com/images/2022/01/404-page-animation-example.gif" alt="404NotFound" />;
}
  